"use strict";

new Vue({
  mixins: [main],
  data: function data() {
    return {
      items: [],
      store: this.getUrlVal('store'),
      area: this.getUrlVal('area'),
      tag: this.getUrlVal('tag'),
      genre: this.getUrlVal('genre'),
      number: 20,
      paged: this.getUrlVal('paged') !== undefined && Number(this.getUrlVal('paged')) >= 1 ? Number(this.getUrlVal('paged')) : 1,
      maxPages: undefined,
      loading: true,
      searchStoreItems: [],
      searchStore: this.getUrlVal('store')
    };
  },
  computed: {
    searchStoreText: function searchStoreText() {
      var _this = this;

      var text = 'すべて';
      this.searchStoreItems.some(function (store) {
        if (store.value === _this.searchStore) {
          text = store.text;
          return true;
        }
      });
      return text;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    axios.get(apiUrl + '/api/get_arrival', {
      params: {
        store: this.store,
        area: isNaN(this.area) ? undefined : this.area,
        tag: this.tag,
        genre: this.genre,
        number: this.number,
        paged: this.paged
      }
    }).then(function (response) {
      _this2.items = response.data.items.map(function (item) {
        return {
          title: item.title,
          img: item.thumbnail ? olineImgUrl + '/' + item.thumbnail : templateDirectoryUri + '/img/no_image_arrival.jpg',
          date: item.date,
          store: item.store.map(function (store) {
            return store.name;
          }),
          url: '/arrival/' + item.id + '/',
          r18Flag: item.r18_flag
        };
      });
      _this2.maxPages = response.data.max_pages;
      _this2.loading = false;
    });
    axios.get(apiUrl + '/api/get_store').then(function (response) {
      var items = response.data.items.filter(function (store) {
        return exStores.indexOf(store.name) === -1;
      }).sort(function (storeA, storeB) {
        return storeA.area - storeB.area;
      }).map(function (store) {
        return {
          text: store.name.replace(/^らしんばん/, ''),
          value: String(store.id)
        };
      });
      items.unshift({
        text: 'すべて',
        value: ''
      });
      _this2.searchStoreItems = items;
    });
  }
});